import { render, staticRenderFns } from "./NaviListMobileResident.vue?vue&type=template&id=6d631454&"
import script from "./NaviListMobileResident.vue?vue&type=script&lang=js&"
export * from "./NaviListMobileResident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports